import { useQuery } from '@tanstack/react-query';
import { getClinicalLocations } from '../services/clinical_locations';

export const useClinicalLocations = (siteId) => {
  return useQuery({
    queryKey: ['clinicalLocations', siteId],
    queryFn: () => getClinicalLocations(siteId),
    enabled: !!siteId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });
};
